"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPluginState = exports.setPluginState = exports.buildAppData = void 0;
var pluginState = {};
/**
 * Utility method for consistently building `getAppData()` and `setAppData()` methods
 * for the plugin hook context.
 * Simply pass in the starting `appData` object and destructure the result.
 *
 * @param appData the appData object that the `getAppData()` and `setAppData()` methods
 * will interact with behind the scenes.
 *
 * @example
 * const { getAppData, setAppData } = buildAppData({ foo: 'bar' });
 */
var buildAppData = function (appData) {
    var dataContainer = {
        appData: __assign({}, (appData || {})),
    };
    var getAppData = function () { return (__assign({}, dataContainer.appData)); };
    function setAppData(update) {
        var newAppData;
        if (typeof update === 'function') {
            /**
             * The length property on functions indicates how many parameters are in its signature.
             * So, we can have a tiny optimization here by not spreading appData when we don't need to.
             */
            if (update.length === 0) {
                newAppData = update();
            }
            else if (update.length >= 1) {
                newAppData = update(__assign({}, dataContainer.appData));
            }
        }
        else if (typeof update === 'object' && update) {
            newAppData = update;
        }
        dataContainer.appData = __assign(__assign({}, dataContainer.appData), (newAppData || {}));
    }
    return {
        getAppData: getAppData,
        setAppData: setAppData,
    };
};
exports.buildAppData = buildAppData;
var setPluginState = function (state) {
    pluginState = __assign(__assign({}, pluginState), state);
};
exports.setPluginState = setPluginState;
var getPluginState = function () {
    return pluginState;
};
exports.getPluginState = getPluginState;
//# sourceMappingURL=build-app-data.js.map